import { NonReportedError, sendErrorEmailGraphql } from '@otuvy/ionic-react-common';
import { graphql } from '../../utils/api/apiUtils';
import packageJson from '../../../package.json';

//Re-export for convenience
export { NonReportedError };

/**
 * Message patterns produced by the network stack (Amplify, fetch, native webview)
 * when a request fails due to connectivity rather than a server/app bug.
 * Errors matching these are thrown as NonReportedError by the graphql wrapper.
 */
export const expectedNetworkErrorPatterns: RegExp[] = [
  /network error/i,
  /network request failed/i,
  /failed to fetch/i,
  /load failed/i,
  /timeout/i,
];

/**
 * Whether the error message indicates an expected transient network failure
 * (device offline, request timed out, connection dropped) as opposed to an
 * unexpected server or application error.
 */
export const isExpectedNetworkError = (message: string): boolean =>
  expectedNetworkErrorPatterns.some((pattern) => pattern.test(message));

export const sendErrorEmail = async (subject: string, body?: string) => {
  sendErrorEmailGraphql({
    subject,
    body,
    appName: packageJson.name,
    appVersion: packageJson.version,
    graphql,
  }).catch((error) => {
    // Never let the error-email side channel become its own unhandled rejection.
    console.error('Failed to send error email: ', error);
  });
};
